<form (ngSubmit)="onSuccessAdd()" [formGroup]="form">
    <div class="dialog-headline" fxLayout="row wrap" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title translate>add_mandataire</h2>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content>

        <div class="pc" fxLayout="row wrap">
            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('staffNm')"
                        [label]="'Nom et prénom'"
                ></app-text-field>
            </div>
        </div>
        <div class="pc" fxLayout="row wrap">
            <div fxFlex.gt-sm="50" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('indRegNo')"
                        [label]="!t?.etranger?'N° de CIN':'passport'"
                        [numberphone]="!t?.etranger "
                ></app-text-field>
            </div>
            <div fxFlex.gt-sm="50" fxFlex.lt-md="100">
                <app-select-date
                        [control]="getFormControl('issuedYmd')"
                        [label]="'Date de délivrance'"
                        [max]="currentDate"
                ></app-select-date>
            </div>
        </div>
        <div class="pc" fxLayout="row wrap">
            <div fxFlex.gt-sm="50" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('positionNm')"
                        [label]="'Fonction'"
                ></app-text-field>
            </div>
            <div fxFlex.gt-sm="50" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('telNo')"
                        [label]="'N° de téléphone fixe'"
                        [number]="true"
                ></app-text-field>
            </div>

        </div>
        <div class="pc" fxLayout="row wrap">
            <div fxFlex.gt-sm="50" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('faxNo')"
                        [label]="'N° de fax'"
                        [number]="true"
                ></app-text-field>
            </div>
            <div fxFlex.gt-sm="50" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('mtelNo')"
                        [label]="'N° de tel portable'"
                        [number]="true"
                ></app-text-field>
            </div>

        </div>

        <div class="pc" fxLayout="row wrap">
            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('email')"
                        [label]="'email'"
                ></app-text-field>
            </div>


        </div>
    </div>
    <div class="pc" fxLayoutAlign="end end" mat-dialog-actions>
        <div fxLayout="row wrap" fxLayoutAlign="center center">
            <button [disabled]="form.invalid" color="primary" mat-raised-button type="submit">
                {{ "submit" | translate }}
            </button>
        </div>
    </div>
</form>
